<div class="bl-display--flex bl-margin-bottom--16">
  <h3 class="bl-font-size--22 bl-font-weight--900 bl-margin-bottom--8">{{ getCardTitle()}} </h3>
  <a id="edit-{{card.id}}" [class.bl-disabled]="card.disableEditInReview" href="javascript:void(0);"  (click)="goToPage()"
    class="bl-col-auto bl-text-decoration--none bl-hover-none bl-margin-y--auto bl-margin-left--auto bl-font-weight--800">
    Edit
  </a>
</div>
